<template>
    <div>

        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
         </div>

         <div class="formulario">
              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">

                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados pessoais'" :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Dados pessoais'"/>

                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">Nome*</label>
                      <input class="field" type="text" id="nome" @change="salvarAlteracoesLocalmente" v-model="localPF.Nome" disabled="true" placeholder="José da Silva">
                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="cpf">CPF*</label>
                      <input  class="field" type="text" id="cpf" @change="salvarAlteracoesLocalmente" v-model="localPF.Cpf" disabled="true" placeholder="123.456.789-10">
                    </div>

                     <div class="label__field"  style="width: 29%">
                      <label class="label" for="situacaoLegal">Situação legal</label>
                      <div>
                        <select
                            style="width: 110% !important;" id="situacaoLegal" @change="salvarAlteracoesLocalmente" v-model="localPF.SituacaoLegal" class="field"
                        >
                            <option value="1">Maior</option>
                            <option value="2">Menor</option>
                            <option value="3">Emancipado</option>
                            <option value="4">Espólio</option>
                            <option value="5">Interditado/Incapaz</option>
                        </select>
                      </div>

                    </div>

                  </div>

                   <div class="row">
                    <div class="label__field" style="width: 25%">
                      <label class="label" for="dataNascimento">Data de nascimento*</label>
                      <input class="field" type="date" id="dataNascimento" @change="checkMenorIdade" v-model="localPF.DataNascimento" placeholder="00/00/0000">
                      <p v-if="camposObrigatorios.erroDataNascimento" class="erro">
                            Campo obrigatório
                      </p>
                    </div>

                  
                    <div class="label__field" style="width: 25%">
                      <label class="label" for="sexo">Sexo*</label>
                      
                    <select
                        id="sexo" @change="salvarAlteracoesLocalmente" v-model="localPF.Sexo" class="field"
                    >
                        <option value="">Selecione</option>
                        <option value="Feminino">Feminino</option>
                        <option value="Masculino">Masculino</option>
                    </select>
                      <p v-if="camposObrigatorios.erroSexo" class="erro">
                            Campo obrigatório
                      </p>
                    </div>

                     <div class="label__field"  style="width: 25%">

                      <label class="label" for="nome">Telefone Celular*</label>
                      <input class="field" type="text" id="nome" v-mask="celularMask" @change="salvarAlteracoesLocalmente" v-model="localPF.Telefone">
                      <p v-if="camposObrigatorios.erroTelefoneCelular" class="erro">
                            Campo obrigatório
                      </p>
                    </div>

                     <div class="label__field" style="width: 25%">

                      <label class="label" for="nome">Telefone Residencial</label>
                      <input class="field" type="text" v-mask="telefoneMask"  id="nome" @change="salvarAlteracoesLocalmente" v-model="localPF.Telefone2">
                
                    </div>

                  </div>


                   <div class="row">
                    <div class="label__field" style="width: 50%">
                      <label class="label" for="nome">Nome do pai*</label>
                      <input class="field" type="text"  @change="salvarAlteracoesLocalmente" v-model="localPF.NomePai" id="nomePai" placeholder="Nome completo">
                      <p v-if="camposObrigatorios.erroNomePai" class="erro">
                            Campo obrigatório
                      </p>
                    </div>

                    <div class="label__field" style="width: 50%">
                      <label class="label" for="cpf">Nome da mãe*</label>
                      <input  class="field" type="text"  @change="salvarAlteracoesLocalmente" v-model="localPF.NomeMae" id="nomeMae" placeholder="Nome completo">
                      <p v-if="camposObrigatorios.erroNomeMae" class="erro">
                            Campo obrigatório
                      </p>
                    </div>

                  </div>

                  <div class="row">
                    <div class="label__field" style="width: 50%">
                      <label class="label" for="nome">Nacionalidade*</label>

                    <select
                        id="tipoCadastro"  @change="salvarAlteracoesLocalmente" v-model="localPF.Nacionalidade" class="field"
                    >
                     <option value="">Selecione</option>
                        <option v-for="nacionalidade in listaNacionalidades" :key="nacionalidade.Descricao" :value="nacionalidade.Descricao">
                        {{ nacionalidade.Descricao }}
                        </option>
                    </select>

                      <p v-if="camposObrigatorios.erroNacionalidade" class="erro">
                            Campo obrigatório
                      </p>

                    </div>

                    <div class="label__field" style="width: 50%">
                      <label class="label" for="Naturalidade">Naturalidade*</label>
                      <input  class="field"  @change="salvarAlteracoesLocalmente" type="text" id="Naturalidade" v-model="localPF.Naturalidade" placeholder="Ex.: São Paulo">
                       <p v-if="camposObrigatorios.erroNaturalidade" class="erro">
                            Campo obrigatório
                        </p>
                    
                    </div>

                  </div>

                  <div class="row">
                    <div class="label__field" style="width: 20%">
                      <label class="label" for="nome">Tipo do documento*</label>
                      <select id="tipoCadastro" class="field" @change="salvarAlteracoesLocalmente" v-model="localPF.TipoDocumento">

                          <option value="">Selecione</option>
                          <option value="RG">RG</option>
                          <option value="CNH">CNH</option>
                          <option value="Passaporte">Passaporte</option>
                          <option value="RNE">Céd. Ident. - Estrangeiro (RNE)</option>
                          <option value="CIM">Céd. Ident. - Militar (CIM)</option>
                          <option value="CIP">Céd. Ident. - Profissional (CIP)</option>
                          <option value="CIPF">Céd. Ident. Prof. - Func Órgão Público (CIPF)</option>
                          <option value="CN">Certidão de Nascimento (CN)</option>
                          <option value="IP">Identificação Prisional (IP)</option>
                          <option value="IE">Inscrição Estadual (IE)</option>
                          <option value="LPASS">Laissez Passer (LPASS)</option>
                          <option value="NIRE">Número Ident. Registro Empresa (NIRE)</option>

                      </select>

                       <p v-if="camposObrigatorios.erroTipoDocumento" class="erro">
                            Campo obrigatório
                        </p>

                    </div>

                    <div class="label__field" style="width: 40%">
                      <label class="label" for="cpf">Nº do documento identificação*</label>
                      <input  class="field"  @change="salvarAlteracoesLocalmente" v-model="localPF.NumeroDocumento" type="text" id="NumeroDocumento">
                                            <p v-if="camposObrigatorios.erroNumeroDocumento" class="erro">
                            Campo obrigatório
                        </p>
                    </div>

                    <div class="label__field" style="width: 40%">
                      <label class="label" for="cpf">Data de emissão*</label>
                      <input  class="field"  @change="salvarAlteracoesLocalmente" v-model="localPF.DataEmissao" type="date" placeholder="00/00/0000">
                        <p v-if="camposObrigatorios.erroDataEmissao" class="erro">
                            Campo obrigatório
                        </p>
                    </div>


                  </div>

                   <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">Órgão emissor*</label>
                      <input class="field"  @change="salvarAlteracoesLocalmente" v-model="localPF.OrgaoEmissao" type="text" id="nome">
                        <p v-if="camposObrigatorios.erroOrgaoEmissao" class="erro">
                            Campo obrigatório
                        </p>
                    
                    </div>

                    <div class="label__field" style="width: 20%">
                      <label class="label" for="DocumentoUf">UF*</label>
                      <select id="DocumentoUf"  @change="salvarAlteracoesLocalmente" v-model="localPF.DocumentoUf"  class="field">
                         <option value="null">Selecione</option>
                        <option v-for="uf in ufs" :key="uf" :value="uf">
                          {{ uf }}
                        </option>
                      </select>
                        <p v-if="camposObrigatorios.erroDocumentoUf" class="erro">
                            Campo obrigatório
                        </p>
                    </div>

                    <div class="label__field" style="width: 40%">
                      <label class="label" for="estadoCivil">Estado civil*</label>
                      <select id="estadoCivil"  @change="salvarAlteracoesLocalmente" class="field" v-model="localPF.EstadoCivil">
                        <option value="">Selecione</option>
                         <option v-for="estadoCivil in estadosCivis" :key="estadoCivil" :value="estadoCivil">
                            {{ estadoCivil }}
                          </option>
                        </select>
                        <p v-if="camposObrigatorios.erroEstadoCivil" class="erro">
                            Campo obrigatório
                        </p>
                    </div>


                  </div>



                </div>
              </div>

             <div class="agrupamentoFormulario" v-if="localPF.EstadoCivil == 'Casado(a)' || localPF.EstadoCivil == 'Em união estável'">
                <div class="categoriaAgrupamentoFormulario">
                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados do Cônjuge'" :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Dados cônjugue'"/>
                </div>
                <div class="camposAgrupamentoFormulario">
                  <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nomeConjugue">Nome*</label>
                      <input class="field" type="text" id="nomeConjugue" @change="salvarAlteracoesLocalmente" v-model="localPF.NomeConjugue">
                        <p v-if="camposObrigatorios.erroNomeConjugue" class="erro">
                            Campo obrigatório
                        </p>
                    
                    </div>

                    <div class="label__field" style="width: 40%">
                      <label class="label" for="cpfConjugue">CPF*</label>
                      <input  class="field" v-mask="'###.###.###-##'" type="text" id="cpfConjugue" @change="salvarAlteracoesLocalmente" v-model="localPF.CpfConjugue">
                        <p v-if="camposObrigatorios.erroCpfConjugue" class="erro">
                            Campo obrigatório
                        </p>
                    </div>
                  </div>
                </div>
               </div>

                <div class="agrupamentoFormulario" v-if="localPF.SituacaoLegal == 5 || localPF.SituacaoLegal == 2 || localPF.SituacaoLegal == 4">
                <div class="categoriaAgrupamentoFormulario">
                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Identificação de represente/tutor'" :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Dados Representante_Tutor'"/>

                </div>
                <div class="camposAgrupamentoFormulario">


                  <div class="row">
                    <div class="label__field" style="width: 30%">
                      <label class="label" for="nomeRepresentante">Nome*</label>
                      <input class="field" type="text" id="nomeRepresentante" @change="salvarAlteracoesLocalmente" v-model="localPF.NomeRepresentante">

                    </div>

                   <div class="label__field"  style="width: 30%">
                      <label class="label" for="situacaoLegal">Grau de relacionamento*</label>
                      <div>
                        <select
                             id="situacaoLegal" @change="salvarAlteracoesLocalmente" v-model="localPF.GrauRelacionamento" class="field"
                        >
                            <option value="1">Pai/Mãe</option>
                            <option value="2">Curador</option>
                            <option value="3">Inventariante</option>
                            <option value="5">Tutor</option>
                        </select>

                      </div>

                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Será emissor de ordem?*</label>
                      <div class="radio">


                                            <input
                                              type="radio"
                                              id="false"
                                              value="false"
                                              name="emissorOrdem"
                                              class="field__radio"
                                              v-model="localPF.EmissorOrdem"
                                              @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                                                                        <input
                                              type="radio"
                                              id="true"
                                              value="true"
                                              name="emissorOrdem"
                                              class="field__radio"
                                              v-model="localPF.EmissorOrdem"
                                              @change="salvarAlteracoesLocalmente"
                                            />

                                            <label
                                                for="sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>
                                        </div>

                    </div>





                  </div>

                  <div class="row">

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="cpf">Nº do documento identificação*</label>
                      <input  class="field"  @change="salvarAlteracoesLocalmente" v-model="localPF.DocumentoRepresentante" type="text" id="NumeroDocumento">
                    </div>


                     <div class="label__field" style="width: 30%">
                      <label class="label" for="cpfConjugue">CPF*</label>
                      <input  class="field" v-mask="'###.###.###-##'"  type="text" id="cpfConjugue" @change="salvarAlteracoesLocalmente" v-model="localPF.CpfRepresentante">
                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">É uma pessoa Exposta Politicamente?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                value="false"
                                                :name="`pepRepresentante`"
                                                class="field__radio"
                                                v-model="localPF.PepRepresentante"
                                                @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="Coligada"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                :name="`pepRepresentante`"
                                                class="field__radio"
                                                v-model="localPF.PepRepresentante"
                                                @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="Controlada"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>


                                        </div>
                    </div>


     
                    </div>



                      <div class="buttonsAcoes" style="padding-bottom: 30px;">
                          <button class="btnDefault" style="width: 290px" @click="habilitarSegundoRepresentante()">+ Adicionar outro representante/tutor</button>
                      </div>


                      

                  <div class="row" v-if="segundoRepresentante">
                    <div class="label__field" style="width: 30%">
                      <label class="label" for="nomeRepresentante">Nome*</label>
                      <input class="field" type="text" id="nomeRepresentante2" @change="salvarAlteracoesLocalmente" v-model="localPF.NomeRepresentante2">
                    </div>

                                         <div class="label__field"  style="width: 30%">
                      <label class="label" for="situacaoLegal">Grau de relacionamento*</label>
                      <div>
                        <select
                             id="situacaoLegal" @change="salvarAlteracoesLocalmente" v-model="localPF.GrauRelacionamento2" class="field"
                        >
                            <option value="1">Pai/Mãe</option>
                            <option value="2">Curador</option>
                            <option value="3">Inventariante</option>
                            <option value="4">Procurador</option>
                            <option value="5">Tutor</option>
                        </select>
                      </div>

                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Será emissor de ordem?*</label>
                      <div class="radio">


                                            <input
                                              type="radio"
                                              id="false"
                                              value="false"
                                              name="emissorOrdem_2"
                                              class="field__radio"
                                              v-model="localPF.EmissorOrdem2"
                                              @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                                                                        <input
                                              type="radio"
                                              id="true"
                                              value="true"
                                              name="emissorOrdem_2"
                                              class="field__radio"
                                              v-model="localPF.EmissorOrdem2"
                                              @change="salvarAlteracoesLocalmente"
                                            />

                                            <label
                                                for="sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>
                                        </div>
                    </div>

                                            <div class="label__field" style="width: 20%; margin-top: 20px">

                                                                     <a
                                            @click.stop.prevent="
                                                desabilitarSegundoRepresentante()
                                            "
                                            class="ico__delete"
                                            title="Excluir empresa"                                            
                                        >
                                            <Icon icon="ico-delete" />
                                            
                                        </a>      

                                        </div>


                  </div>

                  <div class="row" v-if="segundoRepresentante">

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="cpf">Nº do documento identificação*</label>
                      <input  class="field"  @change="salvarAlteracoesLocalmente" v-model="localPF.DocumentoRepresentante2" type="text" id="NumeroDocumento">
                    </div>


                     <div class="label__field" style="width: 30%">
                      <label class="label" for="cpfConjugue">CPF*</label>
                      <input  class="field" type="text" id="cpfConjugue" v-mask="'###.###.###-##'"  @change="salvarAlteracoesLocalmente" v-model="localPF.CpfRepresentante2">
                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">É uma pessoa Exposta Politicamente?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                value="false"
                                                :name="`pepRepresentante_2`"
                                                class="field__radio"
                                                v-model="localPF.PepRepresentante2"
                                                @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="Coligada"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                :name="`pepRepresentante_2`"
                                                class="field__radio"
                                                v-model="localPF.PepRepresentante2"
                                                @change="salvarAlteracoesLocalmente"
                                            />
                                            <label
                                                for="Controlada"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>


                                        </div>
                    </div>


     
                    </div>



                </div>


               </div>





              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados profissionais'" :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Dados profissionais'"/>
                
                </div>
                <div class="camposAgrupamentoFormulario">

                   <div class="row">
                    <div class="label__field"  :style="localPF.Ocupacao == 'outros' ? `width: 25%` : 'width: 33%'">
                      <label class="label" for="formacaoProfissional">Formação Acadêmica*</label>
                      <select
                          id="formacaoProfissional"  @change="salvarAlteracoesLocalmente" v-model="localPF.FormacaoProfissional" class="field"
                      >
                          <option value="null">Selecione</option>

                          <option v-for="item in listaFormacacaoProfissional" :key="item.Descricao" :value="item.Descricao">
                            {{ item.Descricao }}
                          </option>

                      </select>          
                        <p v-if="camposObrigatorios.erroFormacaoProfissional" class="erro">
                            Campo obrigatório
                        </p>          
                      </div>

                    <div class="label__field" :style="localPF.Ocupacao == 'outros' ? `width: 25%` : 'width: 33%'">
                      <label class="label" for="ocupacaoProfissional">Ocupação profissional*</label>
                      <select
                          id="ocupacaoProfissional"  @change="ocupacaoProfissionalAlteracao" class="field" v-model="localPF.Ocupacao"
                      >
                          <option value="null">Selecione</option>

                          <option v-for="item in listaOcupacaoProfissional" :key="item.Codigo" :value="item.Codigo">
                            {{ item.Descricao }}
                          </option>

                      </select>      
                       <p v-if="camposObrigatorios.erroOcupacao" class="erro">
                            Campo obrigatório
                        </p>                  
                      </div>

                    <div class="label__field" style="width: 25%" :style="localPF.Ocupacao == 'outros' ? `display: block` : 'display: none'">
                      <label class="label" for="especifiqueOcupacao">Especifique a ocupação*</label>
                      <input class="field" type="text" id="especifiqueOcupacao" @change="salvarAlteracoesLocalmente" v-model="localPF.OcupacaoOutro">
                                             <p v-if="camposObrigatorios.erroOcupacaoOutro" class="erro">
                            Campo obrigatório
                        </p>     
                    </div>


                  </div>


                </div>
              </div>

              
                
              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados da empresa'" :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Dados empresa'"/>
                
                </div>
                <div class="camposAgrupamentoFormulario">

                  
                   <div class="row">

                    
                   <div class="label__field"   style="width: 50%">
                      <label class="label" for="nomeEmpresa">Nome da empresa</label>
                      <input class="field" type="text" id="nomeEmpresa" v-model="localPF.Instituicao" @change="salvarAlteracoesLocalmente">
                    </div>

                   <div class="label__field"   style="width: 25%">
                      <label class="label" for="especifiqueOcupacao">CNPJ da empresa</label>
                      <input class="field" type="text" id="especifiqueOcupacao" v-mask="'##.###.###/####-##'" @change="salvarAlteracoesLocalmente" v-model="localPF.CnpjTrabalha">
                    </div>

                   </div>
                                      <div class="row">


                    <div class="label__field" style="width: 25%">

                      <label class="label" for="nome">Telefone Comercial</label>
                      <input class="field" type="text" v-mask="'(##) #####-####'"  id="nome" @change="salvarAlteracoesLocalmente" v-model="localPF.TelefoneComercial">
                
                    </div>

                       <div class="label__field" style="width: 25%">

                      <label class="label" for="nome">E-mail Comercial</label>
                      <input class="field" type="text"  id="nome" @change="salvarAlteracoesLocalmente" v-model="localPF.EmailComercial">
                
                    </div>



                   </div>

                </div>
              </div>

         </div>

          <div class="footerFormulario">

            <div class="buttonsAcoes">
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar depois</button>
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
              <button class="btnBlue" @click="proximaEtapa">Avançar</button>
            </div>

          </div> 

    </div>


<ModalInformativoPep />
</template>


<script>

import { mapGetters } from 'vuex';
import ModalInformativoPep  from '../PEP/ModalInformativoPep.vue'
import LabelDisclaimer  from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
    name: 'CadastroPF_Informacoes',
      props: [ 'Edicao'],
      components: {ModalInformativoPep, LabelDisclaimer},
      computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
            listaFormacacaoProfissional: 'GET_LISTA_FORMACAO_PROFISSIONAL',
            listaOcupacaoProfissional: 'GET_LISTA_OCUPACAO_PROFISSIONAL',
            listaNacionalidades: 'GET_LISTA_NACIONALIDADES',
            localPFObjSalvo: 'GET_PF_SALVAR_INFO_BASICAS',
            infoComplementoRepresentantes: 'GET_PF_INFO_BASICAS_REPRESENTANTES',
        }),
    celularMask() {
      const telefoneLimpo = this.localPF.Telefone?.replace(/\D/g, '');

      if (telefoneLimpo?.length <= 11) {
        return '(##) #####-####'; 
      } 
      else {
        return '+(##) (##) ####-#####'; 
      }
    },
    telefoneMask() {
      const telefoneLimpo = this.localPF.Telefone2?.replace(/\D/g, '');

        if (telefoneLimpo?.length < 11) {
          return '(##) ####-####'; 
        } 
        else {
          return '+(##) (##) ####-####'; 
        }

      },
    },
    data() {
      return {
        segundoRepresentante: false,
        permitirAvancar: false,
        representantes: [{
          Guid: '',
          ClienteId: null,
          Nome: '',
          Documento: '',
          Cpf: '',
          EmissorOrdem: false,
          UsPerson: false,
          PoliticamenteExposta: false,
          Tipo: 'tutor'
        }],
        camposObrigatorios: {
          erroDataNascimento: false,
          erroSexo: false,
          erroTelefoneCelular: false,
          erroNomePai: false,
          erroNomeMae: false,
          erroNacionalidade: false,
          erroNaturalidade: false,
          erroTipoDocumento: false,
          erroNumeroDocumento: false,
          erroDataEmissao: false,
          erroOrgaoEmissao: false,
          erroDocumentoUf: false,
          erroEstadoCivil: false,
          erroFormacaoProfissional: false,
          erroOcupacaoOutro: false,
          erroCpfConjugue: false,
          erroNomeConjugue: false
        },
        novoRepresentante: {
          Guid: '',
          ClienteId: null,
          Nome: '',
          Documento: '',
          Cpf: '',
          EmissorOrdem: false,
          UsPerson: false,
          PoliticamenteExposta: false,
          Tipo: 'tutor'
        },
        menorIdade: false,
        localPF: {
          ClienteId: null,
          DataNascimento: null,
          Sexo: '',
          EstadoCivil: '',
          OcupacaoProfissional: '',
          NumeroDocumento: '',
          TipoDocumento: '',
          DataEmissao: null,
          OrgaoEmissao: '',
          DocumentoUf: '',
          Nacionalidade: '',
          Naturalidade: '',
          Pais: '',
          NomeMae: '',
          NomePai: '',
          NomeConjugue: '',
          CpfConjugue: '',
          Logradouro: '',
          LogradouroNumero: '',
          LogradouroComplemento: '',
          Bairro: '',
          Cidade: '',
          Cep: '',
          Uf: '',
          LogradouroPais: '',
          Telefone: '',
          Telefone2: '',
          Email: '',
          PoliticamenteExposta: false,
          PoliticamenteExpostaDescricao: '',
          FormacaoProfissional: '',
          Instituicao: '',
          Ocupacao: '',
          CnpjTrabalha: '',
          EnderecoComercial: '',
          EnderecoComercialNumero: '',
          EnderecoComercialComplemento: '',
          EnderecoComercialBairro: '',
          EnderecoComercialCep: '',
          EnderecoComercialCidade: '',
          EnderecoComercialEstado: '',
          EnderecoComercialPais: '',
          TelefoneComercial: '',
          EmailComercial: '',
          EnderecoCorrespondencia: '',
          LogradouroOutro: '',
          LogradouroNumeroOutro: '',
          LogradouroComplementoOutro: '',
          BairroOutro: '',
          CidadeOutro: '',
          UfOutro: '',
          CepOutro: '',
          PaisOutro: '',
          ClienteIncapaz: false,
          ClienteEmancipado: false,
          NomeRepresentante: '',
          GrauRelacionamento: '',
          EmissorOrdem: false,
          DocumentoRepresentante: '',
          CpfRepresentante: '',
          PepRepresentante: false,
          NomeRepresentante2: '',
          GrauRelacionamento2: '',
          EmissorOrdem2: false,
          DocumentoRepresentante2: '',
          CpfRepresentante2: '',
          PepRepresentante2: false,
          SituacaoLegal: 1,
        // Outras propriedades conforme necessário
        },
        ufs: [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 
        'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 
        'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
       ],
        estadosCivis: [
          'Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 
          'Viúvo(a)', 'Separado(a) judicialmente', 'Em união estável'
        ],
      };
    },
    mounted(){
      if(this.localPFObjSalvo != null && this.localPFObjSalvo.ClienteId == this.infoBasicas.ClienteId){
        this.localPF = this.localPFObjSalvo;
      }else{
        this.localPF = this.formatarDados(this.infoBasicas);
        this.checkMenorIdade();
      }

      if(this.infoComplementoRepresentantes != null && this.infoComplementoRepresentantes.length > 0)
      {
        this.representantes = this.infoComplementoRepresentantes;
      }

      this.representantes[0].ClienteId = this.user.ClienteId;



      this.localPF.Nome = this.infoBasicas.Nome;
      this.localPF.Cpf = this.infoBasicas.Cpf;

      if(this.localPF.NomeRepresentante2 != '' && this.localPF.NomeRepresentante2 != null){
        this.segundoRepresentante = true;
      }

      this.$store.commit('SET_MODAL_PEP_INFORMATIVO', false);

      this.validarFormulario();


    },
    methods: {
      habilitarSegundoRepresentante(){
        this.segundoRepresentante = true;
      },
      desabilitarSegundoRepresentante(){
        this.segundoRepresentante = false;

          this.localPF.NomeRepresentante2 = '';
          this.localPF.GrauRelacionamento2 = '';
          this.localPF.EmissorOrdem2 = false;
          this.localPF.DocumentoRepresentante2 = '';
          this.localPF.CpfRepresentante2 = '';
          this.localPF.PepRepresentante2 = false;

          this.salvarAlteracoesLocalmente();
      },
      checkMenorIdade(){
            var hoje = new Date();
            var dataNascimento = new Date(this.localPF.DataNascimento);
            var idade = hoje.getFullYear() - dataNascimento.getFullYear();
            var m = hoje.getMonth() - dataNascimento.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < dataNascimento.getDate())) {
              idade--;
            }
            this.menorIdade = idade < 18;
          this.salvarAlteracoesLocalmente();
      },
      proximaEtapa(){
        this.validarFormulario(true);

        if(this.permitirAvancar)
        {
          this.$store.commit('SET_ETAPA_CADASTRO', 1);
          this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
          this.salvarInformacoes();
        }
      },
      validarFormulario(submeter)  {
        
        this.permitirAvancar = true;
        this.camposObrigatorios = {
          erroDataNascimento: false,
          erroSexo: false,
          erroTelefoneCelular: false,
          erroNomePai: false,
          erroNomeMae: false,
          erroNacionalidade: false,
          erroNaturalidade: false,
          erroTipoDocumento: false,
          erroNumeroDocumento: false,
          erroDataEmissao: false,
          erroOrgaoEmissao: false,
          erroDocumentoUf: false,
          erroEstadoCivil: false,
          erroFormacaoProfissional: false,
          erroOcupacaoOutro: false,
          erroCpfConjugue: false,
          erroNomeConjugue: false
        };


        var nomeDoCampo = '';

          // Validação de Data de Nascimento (ex: deve ser uma data válida)
          if (!this.localPF.DataNascimento || this.localPF.DataNascimento == null) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroDataNascimento = true;
              nomeDoCampo = 'Data de nascimento';
            }

            this.permitirAvancar = false;

          }


          // Validação de Sexo (ex: deve ser 'M' ou 'F')
          if (!['Masculino', 'Feminino'].includes(this.localPF.Sexo)) {

             if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroSexo = true;
              nomeDoCampo = 'Sexo';
            }
                        this.permitirAvancar =  false;

          }

          // Validação de Telefone (ex: deve ter um formato específico, como números apenas)
          if (!this.localPF.Telefone) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroTelefoneCelular = true;
              nomeDoCampo = 'Telefone Celular';
            }
                        this.permitirAvancar =  false;

          }

          // Validação de Nome do Pai e da Mãe (ex: não deve estar vazio)
          if (!this.localPF.NomePai) {
           if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroNomePai = true;
              nomeDoCampo = 'Nome do Pai';
            }
                        this.permitirAvancar =  false;

          }

           if (!this.localPF.NomeMae) {
            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroNomeMae = true;
              nomeDoCampo = 'Nome da mãe';
            }
                        this.permitirAvancar =  false;

          }

          // Validação de Nacionalidade e Naturalidade (ex: não deve estar vazio)
          if (!this.localPF.Nacionalidade) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroNacionalidade = true;
              nomeDoCampo = 'Nacionalidade';
            }
                        this.permitirAvancar =  false;

          }

          if (!this.localPF.Naturalidade) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroNacionalidade = true;
              nomeDoCampo = 'Naturalidade';
            }
                        this.permitirAvancar =  false;

          }

          // Validação de Tipo de Documento (ex: não deve estar vazio)
          if (!this.localPF.TipoDocumento) {

           if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroTipoDocumento = true;
              nomeDoCampo = 'Tipo do Documento';
            }
                        this.permitirAvancar =  false;

          }


                    if (!this.localPF.NumeroDocumento) {

           if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroNumeroDocumento = true;
              nomeDoCampo = 'Nº do Documento identificação';
            }
                        this.permitirAvancar =  false;

          }


          if(!this.localPF.DataEmissao){

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroDataEmissao = true;
              nomeDoCampo = 'Data de emissão';
            }
                         this.permitirAvancar = false;

          }


          

                    if (!this.localPF.OrgaoEmissao) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroOrgaoEmissao = true;
              nomeDoCampo = 'Orgão emissor';
            }
                        this.permitirAvancar =  false;

          }

          // Validação de Documento UF (ex: deve ser uma UF válida)
          if (!this.ufs.includes(this.localPF.DocumentoUf)) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroDocumentoUf = true;
              nomeDoCampo = 'UF';
            }
                        this.permitirAvancar =  false;

          }

          // Validação de Estado Civil (ex: deve ser um dos estados civis listados)
          if (!this.estadosCivis.includes(this.localPF.EstadoCivil)) {

             if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroEstadoCivil = true;
              nomeDoCampo = 'Estado Civil';
            }
                        this.permitirAvancar =  false;

          }


          if (this.localPF.EstadoCivil == 'Casado(a)' || this.localPF.EstadoCivil == 'Em união estável' ) {

                  if (!this.localPF.NomeConjugue) {

                    if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                      this.camposObrigatorios.erroNomeConjugue = true;
                      nomeDoCampo = 'Nome do Cônjugue';
                    }
                   this.permitirAvancar =  false;

                  }


                  if (!this.localPF.CpfConjugue) {

                    if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                      this.camposObrigatorios.erroCpfConjugue = true;
                      nomeDoCampo = 'CPF do Cônjugue';
                    }
                   this.permitirAvancar =  false;

                  }

          }

          // Validação de Formação Profissional e Ocupação Profissional (ex: não deve estar vazio)
          if (!this.localPF.FormacaoProfissional) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroFormacaoProfissional = true;
              nomeDoCampo = 'Formação Acadêmica';
            }
                        this.permitirAvancar =  false;

          }

         if (!this.localPF.Ocupacao) {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroOcupacao = true;
              nomeDoCampo = 'Ocupação Profissional';
            }
                        this.permitirAvancar =  false;

          }

          if (!this.localPF.OcupacaoOutro && this.localPF.Ocupacao == 'outros') {

            if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
              this.camposObrigatorios.erroOcupacaoOutro = true;
              nomeDoCampo = 'Especifique a ocupação';
            }
            this.permitirAvancar =  false;

          }

          if (submeter && nomeDoCampo != '') {
                  this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo `+ nomeDoCampo +` não foi informado, preencha a informação para avançar`,
                  });
          }
          
      },
      ocupacaoProfissionalAlteracao(){
        this.localPF.OcupacaoOutro = '';
        this.salvarAlteracoesLocalmente();
      },
      salvarInformacoes(){
        this.$store.commit('SET_PF_SALVAR_INFO', true);
      },
      salvarAlteracoesLocalmente(){
        this.validarFormulario();

        this.$store.commit('SET_PF_SALVAR_INFO_BASICAS', this.localPF);
      },
      formatarDados(dados) {

        return {
          ClienteId: dados.ClienteId,
          DataNascimento: this.converterData(dados.DataNascimento),
          Sexo: dados.Sexo || '',
          EstadoCivil: dados.EstadoCivil|| '',
          Ocupacao: dados.Ocupacao || '',
          NumeroDocumento: dados.NumeroDocumento || '',
          TipoDocumento: dados.TipoDocumento || '',
          DataEmissao: this.converterData(dados.DataEmissao),
          OrgaoEmissao: dados.OrgaoEmissao || '',
          DocumentoUf: dados.DocumentoUf || '',
          Nacionalidade: dados.Nacionalidade || '',
          Naturalidade: dados.Naturalidade || '',
          Pais: dados.Pais || '',
          NomeMae: dados.NomeMae || '',
          NomePai: dados.NomePai || '',
          NomeConjugue: dados.NomeConjugue || '',
          CpfConjugue: dados.CpfConjugue || '',
          Logradouro: dados.Logradouro || '',
          LogradouroNumero: dados.LogradouroNumero || '',
          LogradouroComplemento: dados.LogradouroComplemento || '',
          Bairro: dados.Bairro || '',
          Cidade: dados.Cidade || '',
          Cep: dados.Cep || '',
          Uf: dados.Uf || '',
          LogradouroPais: dados.LogradouroPais || '',
          Telefone: dados.Telefone || '',
          Telefone2: dados.Telefone2 || '',
          Email: dados.Email || '',
          PoliticamenteExposta: dados.PoliticamenteExposta,
          PoliticamenteExpostaDescricao: dados.PoliticamenteExpostaDescricao || '',
          FormacaoProfissional: dados.FormacaoProfissional || '',
          Instituicao: dados.Instituicao || '',
          OcupacaoOutro: dados.OcupacaoOutro || '',
          CnpjTrabalha: dados.CnpjTrabalha || '',
          EnderecoComercial: dados.EnderecoComercial || '',
          EnderecoComercialNumero: dados.EnderecoComercialNumero || '',
          EnderecoComercialComplemento: dados.EnderecoComercialComplemento || '',
          EnderecoComercialBairro: dados.EnderecoComercialBairro || '',
          EnderecoComercialCep: dados.EnderecoComercialCep || '',
          EnderecoComercialCidade: dados.EnderecoComercialCidade || '',
          EnderecoComercialEstado: dados.EnderecoComercialEstado || '',
          EnderecoComercialPais: dados.EnderecoComercialPais || '',
          TelefoneComercial: dados.TelefoneComercial || '',
          EmailComercial: dados.EmailComercial || '',
          EnderecoCorrespondencia: dados.EnderecoCorrespondencia || '',
          LogradouroOutro: dados.LogradouroOutro || '',
          LogradouroNumeroOutro: dados.LogradouroNumeroOutro || '',
          LogradouroComplementoOutro: dados.LogradouroComplementoOutro || '',
          BairroOutro: dados.BairroOutro || '',
          CidadeOutro: dados.CidadeOutro || '',
          UfOutro: dados.UfOutro || '',
          CepOutro: dados.CepOutro || '',
          PaisOutro: dados.PaisOutro || '',
          ClienteIncapaz: dados.ClienteIncapaz,
          ClienteEmancipado: dados.ClienteEmancipado,
          NomeRepresentante: dados.NomeRepresentante || '',
          GrauRelacionamento: dados.GrauRelacionamento || '',
          EmissorOrdem: dados.EmissorOrdem,
          DocumentoRepresentante: dados.DocumentoRepresentante || '',
          CpfRepresentante: dados.CpfRepresentante || '',
          PepRepresentante: dados.PepRepresentante,

          NomeRepresentante2: dados.NomeRepresentante2 || '',
          GrauRelacionamento2: dados.GrauRelacionamento2 || '',
          EmissorOrdem2: dados.EmissorOrdem2,
          DocumentoRepresentante2: dados.DocumentoRepresentante2 || '',
          CpfRepresentante2: dados.CpfRepresentante2 || '',
          PepRepresentante2: dados.PepRepresentante2,

          SituacaoLegal: dados.SituacaoLegal || 1
          // Outras propriedades conforme necessário
        };
    },
    converterData(dataString) {
      if (dataString && dataString !== '0001-01-01T00:00:00') {
          let data = new Date(dataString);
          let ano = data.getFullYear();
          let mes = (data.getMonth() + 1).toString().padStart(2, '0'); // adiciona um 0 à esquerda se for de 1 a 9
          let dia = data.getDate().toString().padStart(2, '0');
          return `${ano}-${mes}-${dia}`; // retorna a data no formato 'YYYY-MM-DD'
        } else {
          return null;
        }
    },
    },
    watch: {
      infoBasicas(){
        this.localPF = this.formatarDados(this.infoBasicas);

        this.localPF.Nome = this.infoBasicas.Nome;
        this.localPF.Cpf = this.infoBasicas.Cpf;

        this.validarFormulario();

        this.checkMenorIdade();
      },
      infoComplementoRepresentantes(){
              if(this.infoComplementoRepresentantes != null && this.infoComplementoRepresentantes.length > 0)
      {
        this.representantes = this.infoComplementoRepresentantes;
      }
      },
    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');



.formulario{
  width: 100%;
}

.agrupamentoFormulario{
  width: 100%;
  display: inline-flex;
  margin-top: 10px;
}

.categoriaAgrupamentoFormulario{
  width: 10%;
  margin-right: 15px;

  h5{
        font-family: 'Inter', sans-serif; /* Fonte Inter */
  }

}

.label__field{
  padding-right: 30px;
}

.camposAgrupamentoFormulario{
  width: 90%;

  .row{
    width: 100%;
    display: inline-flex;
    gap: 8px;
    margin-bottom: 10px;
  }

      .accept {
                    display: inline-flex;

                    &:checked {
                      +label {
                            &:before {
                                background: white;
                                border: 1px solid black;
                                transition: background 0.3s;
                            }
                        }

                        +label {
                            &::after {
                                opacity: 1;
                                transition: all;
                                background: transparent;
                            }
                        }
                    }
                }



 .radio {
                display: flex;
                align-items: center;
                margin-right: 25px;

                @media (max-width: 768px) {
                    margin-right: 0;
                    margin-bottom: 20px;
                }

                .field__radio {
                    width: 20px;
                    height: 20px;
                }

                .label__radio {
                    margin-left: 5px;
                    margin-right: 40px;
                    margin-top: 5px;
                }
            }

select{
  width: 105% !important;
}


label {
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    font-weight: 500; /* Peso médio */
    font-size: 14px; /* Tamanho da fonte */
    line-height: 20px; /* Altura da linha */
    color: #344054; /* Cor */
    display: block; /* Garante que a label fique acima do input */
    margin-bottom: 8px; /* Espaçamento entre a label e o input abaixo dela */
}

}





.title{

  border-bottom: 1px solid #EAECF0;

  h3{
    margin-top: 50px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }
}


</style>